export { makeTable, printTable, printTables } from './table.js';
